import { IntegrateWebsiteCard } from "@/integration/IntegrateWebsiteCard";
import { AppPage } from "@/layout/AppLayout";

export function PageIntegrateWebsite() {
  return (
    <AppPage title="Integrate Website">
      <IntegrateWebsiteCard />
    </AppPage>
  );
}
